import React from 'react'
import { Group } from '~/models'
import { TagsField } from '~/ui/app/tags'
import { memo } from '~/ui/component'
import { Center, LanguageField, Panel, Scroller, VBox } from '~/ui/components'
import { FormField, FormFieldHeader } from '~/ui/form'
import { layout } from '~/ui/styling'
import PageField from '../../pages/PageField'
import ParticipantVisibilitySummary from './ParticipantVisibilitySummary'

const MiscellaneousSettings = memo('MiscellaneousSettings', () => {

  return (
    <Scroller>
      <Center>
        <VBox width={480} gap={layout.padding.s}>
          <FormField name='rootPage'>
            {bind => <PageField {...bind}/>}
          </FormField>
          <VBox gap={layout.padding.inline.s}>
            <FormFieldHeader name='participantVisibility'/>
            <Panel padding={layout.padding.s}>
              <ParticipantVisibilitySummary/>
            </Panel>
          </VBox>
          <FormField name='languages' required>
            {bind => <LanguageField {...bind} multi/>}
          </FormField>
          <FormField name='identityGroupTags'>
            {bind => <TagsField Model={Group} {...bind}/>}
          </FormField>
        </VBox>
      </Center>
    </Scroller>
  )

})

export default MiscellaneousSettings